import { useState } from 'react';
import { MdArrowBackIos } from 'react-icons/md';
import { useDashboard } from '../../../context/DashboardContext';
import FlaggedMessages from './FlaggedMessages';
import FlaggedTasks from './FlaggedTasks';
import { HiMenu } from "react-icons/hi";
import FlaggedSideBarList from './FlaggedSideBarList';
import { useSelector } from 'react-redux';

const FlaggedItemsMain = ({ isClose }) => {
    const { flagTab, setFlagTab, flaggedTasks } = useDashboard();
    const { msgs } = useSelector((state) => state.message);
    const [flaggedProjectSidebar, setFlaggedProjectSidebar] = useState(false);

    const handleBack = () => {
        isClose();
    };

    return (
        <div className="createRoomPopup !bg-white animate__animated animate__zoomIn animation_duration bgSurfaceDark">
            <header className="filterFileHeader">
                <div onClick={handleBack} className="allfilterFileHeader !items-center">
                    <MdArrowBackIos className="allFileHeaderIcon thread_eHeaderIcon text-2xl !-mt-0" />
                    <span className="allFileHeaderText !mt-0">Flagged Items ({flagTab === 'messages' ? msgs?.length : flaggedTasks?.length})</span>
                </div>
            </header>
            <div className='h-[46px]'>
                <div className=" flex items-center settingTabsContainer px-3">
                    <div className='w-[10%]' onClick={() => setFlaggedProjectSidebar(!flaggedProjectSidebar)}>
                        <HiMenu className='text-teal-600 text-[28px]' />
                    </div>
                    <div className='flex w-[90%] justify-around items-center'>
                        <div onClick={() => setFlagTab('messages')}>
                            <p className={flagTab === 'messages' ? 'settingHeadTabActive' : 'settingTabHeadText'} >Messages</p>
                        </div>
                        <div onClick={() => setFlagTab('tasks')}>
                            <p className={flagTab === 'tasks' ? 'settingHeadTabActive' : 'settingTabHeadText'} >Tasks</p>
                        </div>
                    </div>
                </div>
            </div>


            {flagTab === 'messages' ? <FlaggedMessages /> :
                flagTab === 'tasks' ? <FlaggedTasks /> : null
            }

            <FlaggedSideBarList type='all_flag_conversation' flaggedProjectSidebar={flaggedProjectSidebar} setFlaggedProjectSidebar={setFlaggedProjectSidebar} />
        </div>
    );
};

export default FlaggedItemsMain;